import { render, staticRenderFns } from "./CopyStakeGamificationCenterSignUpRewardTab.vue?vue&type=template&id=734abdb5&scoped=true&lang=pug"
import script from "./CopyStakeGamificationCenterSignUpRewardTab.vue?vue&type=script&lang=ts"
export * from "./CopyStakeGamificationCenterSignUpRewardTab.vue?vue&type=script&lang=ts"
import style0 from "./CopyStakeGamificationCenterSignUpRewardTab.vue?vue&type=style&index=0&id=734abdb5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734abdb5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VCard,VSwitch})
